import { baseUrl } from "../../../boot/index";
import axios from "axios";

// delete Attendance 
export const deleteAttendance = async (ROWID) => {
  console.log({ ROWID })
  const token = localStorage.getItem("authToken")
  try {
    const response = await axios.delete(`${baseUrl}cleaningappfunctions/hrm/app/v1/delete-timesheet/${ROWID}`, {
      headers: {
        "auth-token": token,
      }
    },)
    return response;
  } catch (error) {
    console.log("Error is - ", error)
    throw error
  }
}

// add Attendance
export const addAttendance = async (formData) => {
    const token = localStorage.getItem("authToken")
    try {
      const response = await axios.post(`${baseUrl}cleaningappfunctions/hrm/app/v1/create-timesheet`, formData, {
        headers: {
          "auth-token": token,
        }
      },)
      return response;
    } catch (error) {
      console.log({ error })
      throw error
    }
  }

// update Attendance
export const updateAttendance = async (data) => {
  console.log({ data })
  const ROWID = data.ROWID
  const token = localStorage.getItem("authToken")
  try {
    const response = await axios.put(`${baseUrl}cleaningappfunctions/hrm/app/v1/update-timesheet/${ROWID}`, data, {
      headers: {
        "auth-token": token,
      }
    },)
    return response;
  } catch (error) {
    throw error
  }
}


// total count Attendance
export const countAttendance = async (formData) => {
  const token = localStorage.getItem("authToken")
  try {
    const response = await axios.get(`${baseUrl}cleaningappfunctions/hrm/app/v1/count-timesheet`, formData, {
      headers: {
        "auth-token": token,
      }
    },)
    return response;
  } catch (error) {
    throw error
  }
}


export const getAttendanceById = async (id) => {
  const token = localStorage.getItem("authToken")
  try {
    const response = await axios.get(`${baseUrl}cleaningappfunctions/hrm/app/v1/get-timesheet/${id.id}`, {
      headers: {
        "auth-token": token,
      }
    },)
    return response;
  } catch (error) {
    throw error
  }
}